import React, { useEffect, useState } from "react";
import useServicesService from "../../../services/useServicesService";
import showToast from "../../../utils/toast";
import "./ServiceAdicionalPanel.css";

type Props = {
  serviceId: number;
  initialCode?: string | null;
  onSaved?: () => void;
};

const ServiceEnaexCodePanel: React.FC<Props> = ({
  serviceId,
  initialCode,
  onSaved,
}) => {
  const [code, setCode] = useState("");
  const { updateAdicional, fetching } = useServicesService();

  useEffect(() => {
    setCode((initialCode ?? "").trim());
  }, [initialCode, serviceId]);

  const handleGuardar = () => {
    updateAdicional(
      serviceId,
      { code: code.trim() },
      {
        onSuccess: () => {
          showToast("Código ENAEX guardado correctamente", "success");
          onSaved?.();
        },
        onError: () => showToast("Error al guardar el código", "error"),
      }
    );
  };

  return (
    <div className="service-adicional-panel">
      <div className="adicional-grid">
        <div className="adicional-block" style={{ gridColumn: "1 / -1" }}>
          <label className="adicional-block-label" htmlFor="enaex-code-input">
            Code
          </label>
          <input
            id="enaex-code-input"
            type="text"
            className="adicional-select"
            style={{ width: "100%", maxWidth: "24rem", padding: "0.55rem 0.75rem" }}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Ingrese el code del servicio"
            maxLength={128}
            autoComplete="off"
          />
        </div>
      </div>
      <div className="adicional-actions">
        <button
          type="button"
          className="adicional-guardar-btn"
          onClick={handleGuardar}
          disabled={fetching.updateAdicional}
        >
          {fetching.updateAdicional ? "Guardando…" : "Guardar"}
        </button>
      </div>
    </div>
  );
};

export default ServiceEnaexCodePanel;
